'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ANALYTICS = exports.CALL_API = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.apiRequestType = apiRequestType;
exports.apiSuccessType = apiSuccessType;
exports.apiFailureType = apiFailureType;
exports.apiGet = apiGet;
exports.apiPost = apiPost;
exports.apiPut = apiPut;
exports.apiDelete = apiDelete;
exports.apiUpload = apiUpload;
exports.apiStatus = apiStatus;
exports.mergeApiStatusArray = mergeApiStatusArray;
exports.mergeApiStatuses = mergeApiStatuses;
exports.shouldFetch = shouldFetch;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _normalizr = require('normalizr');

var _daoActions = require('../action/daoActions');

var _daoStore = require('../store/daoStore');

var _daoConfiguration = require('../configuration/daoConfiguration');

var _Dao = require('../Dao');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Action key that carries API call info interpreted by this Redux middleware.
var CALL_API = exports.CALL_API = 'Call API';
var ANALYTICS = exports.ANALYTICS = 'Analytics';

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.

exports.default = function (store) {
    return function (next) {
        return function (action) {
            var callAPI = action[CALL_API];
            if (typeof callAPI === 'undefined') {
                return next(action);
            }
            var type = callAPI.type;
            var schema = callAPI.schema;
            var url = callAPI.url;
            var method = callAPI.method;
            var data = callAPI.data;
            var onSuccess = callAPI.onSuccess;
            var onFail = callAPI.onFail;
            var onProgress = callAPI.onProgress;
            var filterResponse = callAPI.filterResponse;


            if (typeof type !== 'string') {
                throw new Error('Expected a string action type.');
            }
            if (typeof url !== 'string') {
                throw new Error('Specify a string url.');
            }
            if (typeof method !== 'string') {
                throw new Error('Specify a string method.');
            }

            function actionWith(data) {
                var finalAction = Object.assign({}, action, data);
                delete finalAction[CALL_API];
                delete finalAction[ANALYTICS];
                return finalAction;
            }

            function logAnalytics() {
                var analytics = action[ANALYTICS];
                if ((typeof analytics === 'undefined' ? 'undefined' : _typeof(analytics)) === 'object') {
                    (0, _daoConfiguration.getDaoAnalytics)().sendEvent(analytics);
                }
            }

            function mExecute(url, method, data, onProgress) {
                return checkForReauth(function () {
                    return (0, _Dao.execute)(url, method, data, onProgress, (0, _daoStore.getAuthToken)(store.getState()));
                });
            }

            function checkForReauth(promise) {
                return promise().then(undefined, function (err) {
                    if (err.status === 401) {
                        if ((0, _daoStore.getRefreshToken)(store.getState())) {
                            return reauth(promise, store.getState());
                        } else {
                            return Promise.reject({
                                status: -1,
                                payload: {}
                            });
                        }
                    }
                    throw err;
                });
            }

            function reauth(promise) {
                if ((0, _daoStore.isRefreshingAuthToken)(store.getState())) {
                    return wait(promise);
                } else {
                    next((0, _daoActions.refreshAuthToken)());
                    return (0, _Dao.post)('/api/auth/refresh', {
                        refreshTokenId: (0, _daoStore.getRefreshToken)(store.getState())
                    }).then(function (data) {
                        next((0, _daoActions.refreshAuthTokenSuccess)(data));
                        return promise();
                    }, function (error) {
                        return Promise.reject({
                            status: -1,
                            payload: {}
                        });
                    });
                }
            }

            function wait(promise) {
                if ((0, _daoStore.isRefreshingAuthToken)(store.getState())) {
                    return new Promise(function (resolve, reject) {
                        setTimeout(function () {
                            resolve(wait(promise));
                        }, 10);
                    });
                } else {
                    return promise();
                }
            }

            next(actionWith({ type: apiRequestType(type) }));

            return mExecute(url, method, data, onProgress).then(function (response) {
                response = schema ? (0, _normalizr.normalize)(filterResponse ? filterResponse(response) : response, schema) : response;
                logAnalytics();
                onSuccess && onSuccess(response);
                return next(actionWith({
                    type: apiSuccessType(type),
                    response: response,
                    receivedAt: (0, _moment2.default)()
                }));
            }, function (error) {
                if (error.status === -1) {
                    return next((0, _daoActions.unauthorised)());
                } else {
                    onFail && onFail(error);
                    return next(actionWith({
                        type: apiFailureType(type),
                        error: error.payload || error || 'Something bad happened',
                        receivedAt: (0, _moment2.default)()
                    }));
                }
            });
        };
    };
};

function apiRequestType(type) {
    return type + '_REQUEST';
}

function apiSuccessType(type) {
    return type + '_SUCCESS';
}

function apiFailureType(type) {
    return type + '_FAILURE';
}

function apiGet(action, filterState) {
    var callAPI = action[CALL_API];
    if (typeof callAPI === 'undefined') {
        throw new Error('Specify a callAPI description');
    }
    callAPI.method = 'GET';

    if (typeof filterState !== 'function') {
        throw new Error('Specify a function filterState.');
    }

    return function (dispatch, getState) {
        var fieldState = filterState(getState());
        if (!shouldFetch(fieldState)) {
            return;
        }
        return dispatch(action);
    };
}

function apiPost(action) {
    return apiChange(action, 'POST');
}

function apiPut(action) {
    return apiChange(action, 'PUT');
}

function apiDelete(action) {
    return apiChange(action, 'DELETE');
}

function apiUpload(action) {
    return apiChange(action, 'UPLOAD');
}

function apiChange(action, method) {
    var callAPI = action[CALL_API];
    if (typeof callAPI === 'undefined') {
        throw new Error('Specify a callAPI description');
    }
    callAPI.method = method;

    return function (dispatch, getState) {
        return dispatch(action);
    };
}

function apiStatus(field) {
    return {
        isFetching: field ? field.isFetching : false,
        missingData: !field || !field.data,
        hasError: field ? field.hasError : false,
        lastUpdated: field ? field.lastUpdated : undefined,
        didInvalidate: field ? field.didInvalidate : false
    };
}

function mergeApiStatusArray(statuses) {
    var currentStatus = initialStatus();
    statuses.forEach(function (status) {
        currentStatus = mergeStatus(currentStatus, status);
    });

    return currentStatus;
}

function mergeApiStatuses() {
    var currentStatus = initialStatus();

    for (var _len = arguments.length, statuses = Array(_len), _key = 0; _key < _len; _key++) {
        statuses[_key] = arguments[_key];
    }

    statuses.forEach(function (status) {
        currentStatus = mergeStatus(currentStatus, status);
    });

    return currentStatus;
}

function initialStatus() {
    return {
        isFetching: false,
        missingData: false,
        hasError: false,
        didInvalidate: false,
        lastUpdated: undefined
    };
}

function mergeStatus(currentStatus, status) {
    return {
        isFetching: status.isFetching || currentStatus.isFetching,
        missingData: status.missingData || currentStatus.missingData,
        hasError: status.hasError || currentStatus.hasError,
        didInvalidate: status.didInvalidate || currentStatus.didInvalidate,
        lastUpdated: !currentStatus.lastUpdated || status.lastUpdated && status.lastUpdated.isBefore(currentStatus.lastUpdated) ? status.lastUpdated : currentStatus.lastUpdated
    };
}

function shouldFetch(field) {
    if (!field || (0, _isEmpty2.default)(field)) {
        return true;
    }
    if (field.isFetching) {
        return false;
    }
    return field.hasError || field.didInvalidate;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/middleware/apiMiddleware.js
 ** module id = 265
 ** module chunks = 0
 **/